import React, { useEffect, useState } from 'react';

import { Button, Container, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/system'

import { defaultListSettings, ListFilterMode, ListOrder, ListSettings } from '../repositories/models/listSettings';

const FormControlContainer = styled(Container)({
    paddingTop: '10px'
})

interface ListFilterArguments {
    open: boolean,
    settings: ListSettings,
    onSave: (settings: ListSettings) => void,
    handleClose: () => void
}

export default function ListFilter({ open, settings, onSave, handleClose }: ListFilterArguments) {
    const [order, setOrder] = useState<ListOrder>(settings.order)
    const [filter, setFilter] = useState<ListFilterMode>(settings.filter)

    // discard unsaved changes whenever the dialog is (re)opened
    useEffect(() => {
        if (open) {
            setOrder(settings.order)
            setFilter(settings.filter)
        }
    }, [open, settings])

    return <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        fullWidth={true}
        aria-describedby="alert-dialog-slide-description"
    >
        <DialogTitle>List filter</DialogTitle>
        <DialogContent style={{ paddingTop: '10px' }}>
            <FormControlContainer>
                <FormControl fullWidth>
                    <InputLabel id="order_label">Order</InputLabel>

                    <Select
                        labelId="order_label"
                        id="order"
                        label="Order"
                        value={order}
                        onChange={e => setOrder(e.target.value as ListOrder)}
                    >
                        <MenuItem value="name">Name</MenuItem>
                        <MenuItem value="updated">Updated</MenuItem>
                    </Select>
                </FormControl>
            </FormControlContainer>

            <FormControlContainer>
                <FormControl fullWidth>
                    <InputLabel id="filter_label">Filter</InputLabel>

                    <Select
                        labelId="filter_label"
                        id="filter"
                        label="Filter"
                        value={filter}
                        onChange={e => setFilter(e.target.value as ListFilterMode)}
                    >
                        <MenuItem value="all">All</MenuItem>
                        <MenuItem value="only_unchecked">Only unchecked</MenuItem>
                        <MenuItem value="modified_in_last_hour">Modified in last hour</MenuItem>
                        <MenuItem value="modified_today">Modified today</MenuItem>
                    </Select>
                </FormControl>
            </FormControlContainer>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => onSave(defaultListSettings)}>Reset</Button>
            <Button onClick={() => onSave({ order, filter })} color='success'>Save</Button>
            <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
    </Dialog>
}
